import HelpIcon from "../assets/images/Help_icon.svg";
import HelpIconDark from "../assets/images/help_icon_dark.svg";
import DarkModeMoon from "../assets/images/Dark_mode_Moon.svg";
import DarkModeSun from "../assets/images/Sun_icon_dark.svg";
import LightModeSunicon from "../assets/images/Sun_icon_dark.svg";
import LogoutIcon from "../assets/images/Logout.svg";
import LogoutIconDark from "../assets/images/DarkLogOut.svg";
import DashboardfavIcon from "../assets/images/plus-circle.svg";
import DashboardfavIconDark from "../assets/images/plus-circle-dark.svg";
import HomeIcon from "../assets/images/Home.svg";
import HomeIconDark from "../assets/images/Home_icon_dark.svg";
import TargetArrowIcon from "../assets/images/Target Arrow.svg";
import ArrowRightIcon from "../assets/images/Arrow Right.svg";
import Apexlogo from "../assets/images/Apex-Logo.svg";
import RightArrowWhite from "../assets/images/RightArrowWhite.svg";
import ApexLogoDark from "../assets/images/Apex-Logo_dark.svg";
import { useTheme } from "../ThemeContext/ThemeContext.tsx";
import PrintIcon from "../assets/images/Print.svg";
import PrintIconDark from "../assets/images/Print_dark.svg";
import HistoryIcon from "../assets/images/History.svg";
import HistoryIconDark from "../assets/images/History_dark.svg";
import AttchIcon from "../assets/images/Attach.svg";
import AttchIconDark from "../assets/images/Attach_dark.svg";
import RevisionHistoryIcon from "../assets/images/Revision_History.svg";
import RevisionHistoryIconDark from "../assets/images/Revision_History_Dark.svg";
import NewWindow from "../assets/images/Window_New.svg";
import AverageNew from "../assets/images/Average_New.svg";
import AverageNewDark from "../assets/images/Average_New_Dark.svg";
import Plan_Closure from "../assets/images/Plan_Closure.svg";
import Plan_Closure_Dark from "../assets/images/Plan_Closure_Dark.svg";
import SlidersIcon from "../assets/images/Sliders.svg";
import SlidersIconDark from "../assets/images/Sliders_Dark.svg";

const ICONS = () => {
  const { isDarkMode } = useTheme();

  const icons = isDarkMode
    ? {
        Plan_Closure: Plan_Closure_Dark,
        HelpIcon: HelpIconDark,
        DarkModeMoon: DarkModeSun,
        LightModeSunicon: LightModeSunicon,
        LogoutIcon: LogoutIconDark,
        DashboardfavIcon: DashboardfavIconDark,
        HomeIcon: HomeIconDark,
        TargetArrowIcon: TargetArrowIcon,
        ArrowRightIcon: ArrowRightIcon,
        Apexlogo: ApexLogoDark,
        RightArrowWhite: RightArrowWhite,
        PrintIcon: PrintIconDark,
        HistoryIcon: HistoryIconDark,
        AttchIcon: AttchIconDark,
        RevisionHistoryIcon: RevisionHistoryIconDark,
        NewWindow: NewWindow,
        AverageNew: AverageNewDark,
        SlidersIcon: SlidersIconDark,
      }
    : {
        HelpIcon: HelpIcon,
        DarkModeMoon: DarkModeMoon,
        LightModeSunicon: LightModeSunicon,
        LogoutIcon: LogoutIcon,
        DashboardfavIcon: DashboardfavIcon,
        HomeIcon: HomeIcon,
        TargetArrowIcon: TargetArrowIcon,
        ArrowRightIcon: ArrowRightIcon,
        Apexlogo: Apexlogo,
        RightArrowWhite: RightArrowWhite,
        PrintIcon: PrintIcon,
        HistoryIcon: HistoryIcon,
        AttchIcon: AttchIcon,
        RevisionHistoryIcon: RevisionHistoryIcon,
        NewWindow: NewWindow,
        AverageNew: AverageNew,
        SlidersIcon: SlidersIcon,
        Plan_Closure: Plan_Closure,
      };

  return icons;
};
export default ICONS;
